import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { QairoLogo } from "../components/QairoLogo";
import { formatApiError } from "../lib/formatApiError";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/dashboard");
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="border-b border-black">
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <Link to="/"><QairoLogo variant="light" /></Link>
          <Link to="/register" className="text-sm font-medium hover:text-[#0066FF]">Sign up</Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="border border-black p-8 rounded-xl">
            <h1 className="text-2xl font-bold mb-6">Welcome back</h1>
            {error && <div className="bg-red-50 border border-red-500 text-red-700 p-3 mb-4 text-sm" data-testid="login-error">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-xs uppercase tracking-[0.2em] font-bold block mb-2">Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-black p-3 focus:ring-2 focus:ring-[#0066FF] outline-none rounded-lg" required data-testid="login-email" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-[0.2em] font-bold block mb-2">Password</label>
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-black p-3 focus:ring-2 focus:ring-[#0066FF] outline-none rounded-lg" required data-testid="login-password" />
              </div>
              <button type="submit" disabled={loading} className="w-full bg-[#0066FF] text-white py-3 font-bold hover:bg-[#0052CC] transition-colors disabled:opacity-50 rounded-lg" data-testid="login-submit">
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>
            <p className="text-center mt-6 text-sm">
              Don't have an account? <Link to="/register" className="text-[#0066FF] font-bold">Sign up</Link>
            </p>
            <p className="text-center mt-2 text-sm">
              <Link to="/forgot-password" className="text-gray-500 hover:text-[#0066FF]" data-testid="forgot-password-link">Forgot password?</Link>
            </p>
          </div>
        </div>
      </main>

      <footer className="py-8 px-8 border-t border-black bg-black text-white">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <QairoLogo variant="dark" />
          <p className="text-sm text-gray-400">&copy; 2026 QAIRO AI. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
